const env = require('../helpers/env.js');
const hasOpenTokSupport = require('./hasOpenTokSupport.js').once;

module.exports = () => hasOpenTokSupport() && ['Chrome', 'Safari', 'Firefox'].indexOf(env.name) !== -1;
